import { Grid2, TextField, Typography } from "@mui/material";
import { TextFieldStyles } from "../../styles/commonStyles";

const AddressFields = ({ register, title, fieldPrefix }) => {
  return (
    <>
      <Typography fontWeight="bold" fontSize="14px">
        {title}
      </Typography>
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <TextField
            variant="filled"
            id={`${fieldPrefix}.street`}
            label="Via"
            fullWidth
            sx={TextFieldStyles}
            {...register(`${fieldPrefix}.street`)}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 3 }}>
          <TextField
            variant="filled"
            id={`${fieldPrefix}.street_number`}
            label="N. Civico"
            fullWidth
            sx={TextFieldStyles}
            {...register(`${fieldPrefix}.street_number`)}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 3 }}>
          <TextField
            variant="filled"
            id={`${fieldPrefix}.cap`}
            label="CAP"
            fullWidth
            sx={TextFieldStyles}
            {...register(`${fieldPrefix}.cap`)}
          />
        </Grid2>
      </Grid2>
      <Grid2 container spacing={2} mt={2}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <TextField
            variant="filled"
            id={`${fieldPrefix}.city`}
            label="Città"
            fullWidth
            sx={TextFieldStyles}
            {...register(`${fieldPrefix}.city`)}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <TextField
            variant="filled"
            id={`${fieldPrefix}.country`}
            label="Stato"
            fullWidth
            sx={TextFieldStyles}
            {...register(`${fieldPrefix}.country`)}
          />
        </Grid2>
      </Grid2>
    </>
  );
};

export default AddressFields;
